export default __webpack_public_path__ + "static/media/Himalayas-4.cfb3a5d5.jpg";